import { LightningElement, api, wire } from "lwc";
import { LabelsAdapter, LabelsAdapterValue } from "common/labelsAdapter";

import * as locales from "./locales";

export default class StarRating extends LightningElement {
  @api rating: number | string | null = null;
  @api showLabel = false;

  @wire(LabelsAdapter, { locales, options: "$labelOptions" })
  private labels: LabelsAdapterValue = {};

  get style() {
    return `--rating: ${this.rating}`;
  }

  private get labelOptions() {
    return {
      label: { rating: this.rating ?? "..." },
      shortLabel: { rating: this.rating ?? "..." },
    };
  }
}
